import React, {useState, useEffect} from "react";
import { useSelector, useDispatch } from "react-redux";
import { getStoreInfo, loadApi } from "../redux/api/actions";
import { Link } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram, faFacebook } from "@fortawesome/free-brands-svg-icons";

const Footer = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true)

  const mamaApi = useSelector((state) => state.apiReducer);

  const getInfo = async () => {
    let results = await getStoreInfo().then((response) => {
      dispatch(loadApi(response.data))
      setLoading(false)
    })
  }

useEffect(() => {
    getInfo()
  }, []);

  return loading === true ? (
    <div className="loading">
      <Spinner animation="border" role="status" variant="dark"/>
    </div>
  ) : (
    <div>
      <div className="container-fluid contactContainer text-center d-none d-lg-block">
          <div className="logoContact pt-5">
            <img src={process.env.REACT_APP_IMAGE_STORAGE + mamaApi.store.icon_image_path} alt="" />
          </div>
          <h4 className="p-4 group">ZINC GROUP</h4>
                    <div className="row">
                        <div className="">
                            <p className="headOffice">HEAD OFFICE</p>
                            <p className="officeAddress">{mamaApi.store.address}</p>
                            <p className="tel">T: {mamaApi.store.phone}</p>
                            <p className="email">E: {mamaApi.store.email}</p>
                        </div>
                    </div>
                </div>
      <div className="bigFooter d-none d-lg-block">
        <div className="container-fluid p-4 border-bottom">
          <div className="row">
            <div className="col-3 d-flex align-items-center justify-content-center">
              <Link to="/" className="a">
                <img src={process.env.REACT_APP_IMAGE_STORAGE + mamaApi.store.icon_image_path} height="50vmax" alt="" />
              </Link>
              <Link to="/" className="a">
                <h5 className="m-0">ZINC GROUP</h5>
              </Link>
            </div>
            <div className="col-9 pt-3 d-flex justify-content-evenly align-items-center footer-top">
            <Link to="/venue" ><p>VENUES</p></Link>
              <Link to="/about" ><p>ABOUT</p></Link>
              {/* <Link to="/service" ><p>SERVICE</p></Link> */}
              <Link to="/happenings" ><p>HAPPENINGS</p></Link>
              {/* <Link to="/people" ><p>PEOPLE</p></Link> */}
              <Link to="/gallery" ><p>GALLERY</p></Link>
              <Link to="/contact" ><p>Contact</p></Link>
            </div>
          </div>
        </div>
        <div className="container-fluid underBorder">
          <div className="row my-3">
            <div className="col-4 pt-4">
                <h4></h4>
              <p>
                {mamaApi.store.footer_text}
              </p>
              <p>&copy; Zinc Group all rights reserved</p>
            </div>
            <div className="col-4">
              <div className="container">
                <div className="row">
                  <h3>Our Venues</h3>
                  {mamaApi.venues.map((venue) => {
                    return (
                      <div className="col-6 text-start" key={venue.id}><a target="_blank" rel="noreferrer" href={venue.website}>{venue.name}</a></div>
                    )
                  })}
                </div>
              </div>
            </div>

            <div className="col-4">
              <div className="container">
                <div className="row">
                  <h3>Stay In Touch</h3>
                  <p>Join Us</p>
                  <p>Subscribe</p>
                  <div className="spacing foot_media d-flex justify-content-start">
                <a href={mamaApi.store.ig_link}><FontAwesomeIcon icon={faInstagram} /></a>
                <a href={mamaApi.store.facebook_link}><FontAwesomeIcon icon={faFacebook} /></a>
              </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="d-lg-none smallFooter text-center">
        <div className="container">
          <div className="row">
            <div className="inTouch">
              <h2>Stay In Touch</h2>
              <p>Join us</p>
              <p className="spacing">Suscribe</p>
              <div className="spacing foot_media d-flex justify-content-center">
                <a href={mamaApi.store.ig_link}><FontAwesomeIcon icon={faInstagram} /></a>
                <a href={mamaApi.store.facebook_link}><FontAwesomeIcon icon={faFacebook} /></a>
              </div>
            </div>
            <div className="venues">
                <h2 className="venue">Our Venues</h2>
                <div className="container">
              <div className="row">
                {mamaApi.venues.map((venue) => {
                    return (
                      <div className="col-6 venueList" key={venue.id}><a href={venue.website}>{venue.name}</a></div>
                    )
                  })}
              </div></div>
            </div>
            <div className="lastFooter">
              <p>{mamaApi.store.footer_text}</p>
              <p>&copy; Zinc Group all rights reserved</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
